import { render, staticRenderFns } from "./editCategory.vue?vue&type=template&id=58fd8eaf&scoped=true&"
import script from "./editCategory.vue?vue&type=script&lang=js&"
export * from "./editCategory.vue?vue&type=script&lang=js&"
import style0 from "./editCategory.vue?vue&type=style&index=0&id=58fd8eaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd8eaf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58fd8eaf')) {
      api.createRecord('58fd8eaf', component.options)
    } else {
      api.reload('58fd8eaf', component.options)
    }
    module.hot.accept("./editCategory.vue?vue&type=template&id=58fd8eaf&scoped=true&", function () {
      api.rerender('58fd8eaf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchant/editCategory.vue"
export default component.exports